function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "hide",
  transform: "translate(0 -0.293)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_133",
  "data-name": "Path 133",
  d: "M.5,8S3.5,2.5,8,2.5,15.5,8,15.5,8s-3,5.5-7.5,5.5S.5,8,.5,8Z",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_134",
  "data-name": "Path 134",
  d: "M5,8A3,3,0,0,1,8,5",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_135",
  "data-name": "Path 135",
  d: "M11,8a3,3,0,0,1-3,3",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_1287",
  "data-name": "Line 1287",
  y1: 14,
  x2: 14,
  transform: "translate(1 1)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}));

var SvgEyeInactive = function SvgEyeInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15.414,
    viewBox: "0 0 16 15.414",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-inactive.f64d01b8.svg";
export { ForwardRef as ReactComponent };